import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";

export default class PropertyList extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      pending: false,
    };
  }

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.load();
    }
  }

  load = async () => {
    this.setState({ pending: true });
    const { id, referencekey, reference } = this.props;

    let filter = {};
    filter[referencekey] = id;

    let items = await this.context.api.qa(`/${reference}/property/list`, {
      filter,
      orderby: ["sequence ASC"],
    });
    this.setState({
      pending: false,
      items,
    });
  };

  render() {
    const { pending, items } = this.state;
    const { title, hidePending } = this.props;
    return (
      <>
        <Blocker hAuto on={pending && !hidePending}>
          {items.length > 0 && title}
          {items.map((item, idx) => {
            let measureName = item.measure ? item.measure.name : "";
            return (
              <div className="row" key={idx}>
                <div className="col-lg-6 my-2">{item.property.name}</div>
                <div className="col-lg my-2">
                  {item.value}{" "}
                  <span className="text-muted small">{measureName}</span>
                </div>
              </div>
            );
          })}
        </Blocker>
      </>
    );
  }
}
